import React, { useState } from 'react';
import { Container, Row, Col, Card, Table, Button, Badge, Form, InputGroup } from 'react-bootstrap';
import { MdSearch, MdFilterList, MdAdd, MdEdit, MdDelete, MdVisibility } from 'react-icons/md';

const Orders: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const orders = [
    { id: 'ORD-001', customer: 'John Doe', amount: 299.99, status: 'Completed', date: '2025-01-15' },
    { id: 'ORD-002', customer: 'Jane Smith', amount: 149.50, status: 'Pending', date: '2025-01-14' },
    { id: 'ORD-003', customer: 'Bob Johnson', amount: 89.99, status: 'Processing', date: '2025-01-13' },
    { id: 'ORD-004', customer: 'Alice Brown', amount: 199.99, status: 'Completed', date: '2025-01-12' },
    { id: 'ORD-005', customer: 'Charlie Wilson', amount: 79.99, status: 'Cancelled', date: '2025-01-11' }
  ];

  const getStatusBadge = (status: string) => {
    const variants: { [key: string]: string } = {
      'Completed': 'success',
      'Pending': 'warning',
      'Processing': 'info',
      'Cancelled': 'danger'
    };
    return <Badge bg={variants[status] || 'secondary'}>{status}</Badge>;
  };

  const filteredOrders = orders.filter(order =>
    order.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
    order.customer.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Container fluid className="py-4">
      <div className="page-header mb-4">
        <h2>Order Management System</h2>
        <p className="text-muted">Manage and track all customer orders</p>
      </div>

      <Row className="mb-4">
        <Col>
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Orders List</h5>
              <Button variant="primary">
                <MdAdd className="me-1" />
                New Order
              </Button>
            </Card.Header>
            <Card.Body>
              <Row className="mb-3">
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text>
                      <MdSearch />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search orders..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </InputGroup>
                </Col>
                <Col md={6} className="text-end">
                  <Button variant="outline-secondary" className="me-2">
                    <MdFilterList className="me-1" />
                    Filter
                  </Button>
                </Col>
              </Row>

              <Table responsive hover>
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Customer</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredOrders.map((order) => (
                    <tr key={order.id}>
                      <td>{order.id}</td>
                      <td>{order.customer}</td>
                      <td>${order.amount}</td>
                      <td>{getStatusBadge(order.status)}</td>
                      <td>{order.date}</td>
                      <td>
                        <Button variant="outline-primary" size="sm" className="me-1">
                          <MdVisibility />
                        </Button>
                        <Button variant="outline-secondary" size="sm" className="me-1">
                          <MdEdit />
                        </Button>
                        <Button variant="outline-danger" size="sm">
                          <MdDelete />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md={4}>
          <Card>
            <Card.Header>
              <h6 className="mb-0">Order Statistics</h6>
            </Card.Header>
            <Card.Body>
              <div className="d-flex justify-content-between mb-2">
                <span>Total Orders:</span>
                <strong>1,247</strong>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <span>Completed:</span>
                <strong className="text-success">892</strong>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <span>Pending:</span>
                <strong className="text-warning">234</strong>
              </div>
              <div className="d-flex justify-content-between">
                <span>Cancelled:</span>
                <strong className="text-danger">121</strong>
              </div>
            </Card.Body>
          </Card>
        </Col>
        
        <Col md={8}>
          <Card>
            <Card.Header>
              <h6 className="mb-0">Recent Activity</h6>
            </Card.Header>
            <Card.Body>
              <div className="activity-list">
                <div className="activity-item mb-3">
                  <div className="d-flex justify-content-between">
                    <span>Order ORD-001 completed</span>
                    <small className="text-muted">2 hours ago</small>
                  </div>
                </div>
                <div className="activity-item mb-3">
                  <div className="d-flex justify-content-between">
                    <span>New order ORD-006 created</span>
                    <small className="text-muted">4 hours ago</small>
                  </div>
                </div>
                <div className="activity-item mb-3">
                  <div className="d-flex justify-content-between">
                    <span>Order ORD-002 status updated</span>
                    <small className="text-muted">6 hours ago</small>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Orders;
